import { Typography } from 'antd'
import { formatNumber } from '../../utils/function.utils'
import './list-page.scss'

const { Title, Text } = Typography

export const ListPageShell = ({ children, className = '' }) => (
	<div className={`list-page ${className}`.trim()}>{children}</div>
)

export const ListPageIntro = ({ icon: Icon, title, subtitle, children }) => (
	<div className="list-page__intro">
		<div className="list-page__title-row">
			{Icon && <Icon className="list-page__icon" />}
			<div>
				{title && (
					<Title level={4} className="list-page__title">
						{title}
					</Title>
				)}
				{subtitle && (
					<Text type="secondary" className="list-page__subtitle">
						{subtitle}
					</Text>
				)}
			</div>
		</div>
		{children}
	</div>
)

export const ListPageTotal = ({ total }) => (
	<div className="list-page-total">
		<Text type="secondary">Total</Text>
		<span className="list-page-total__value">{formatNumber(total)}</span>
	</div>
)
